<template>
    <div class="bookshelf">
        <div class="title">
            <span @click="filter = true">筛选</span>
            <i></i>
            <span @click="category = true">移入其他类别</span>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-checkbox-group v-model="result" ref="checkboxGroup">
                <van-cell v-for="(item, index) in list" :key="index">
                    <template #title>
                        <van-checkbox :name="item.caseId"></van-checkbox>
                        <span class="custom-title"> {{ index + 1 }} {{ item.title }}</span>
                        <p class="au">{{ item.author }}</p>
                        <span style=" line-height: 1.5rem;font-size:0.8rem"> {{ item.postdate }}</span>
                        <p class="btnP">
                            <a href="javascript:;" v-if="item.status == 1">处理中</a>
                            <!-- <a :href="item.pdfUrl" v-if="item.status == 2 && item.pdfUrl">下载</a> -->
                            <a :href="item.pdfUrl" v-if="item.status == 2 && item.pdfUrl">预览</a>
                            <a href="javascript:;" v-if="item.status == 4" @click="reapply(item.caseId)">已过期, 重新申请</a>
                            <button style="background: #3da7f8;color:#fff" v-if="giveup != '1'" @click="update(item.caseId, 1)">加入回收站</button>
                            <a href="javascript:;" style="background: #3da7f8;color:#fff" v-if="giveup == 1" @click="update(item.caseId, 0)">还原</a>
                            <a href="javascript:;" style="background: #3da7f8;color:#fff" v-if="giveup == 1" @click="update(item.caseId, -1)"
                                >彻底删除</a
                            >
                        </p>
                    </template>
                </van-cell>
            </van-checkbox-group>
        </van-list>

        <van-popup v-model="filter" closeable close-icon-position="top-right" position="bottom" :style="{ height: '90%' }">
            <h1>筛选</h1>
            <div>
                <div class="type">
                    <h2><img src="/layuiadmin/account/img/type.png" alt="" /> 类别筛选</h2>
                    <van-radio-group v-model="typeid">
                        <van-cell-group>
                            <van-cell title="未分类" clickable @click="categoryFun('0')">
                                <template #right-icon> <van-radio name="0" /> </template>
                            </van-cell>
                            <van-cell title="回收站" clickable @click="categoryFun('')">
                                <template #right-icon> <van-radio name="" /> </template>
                            </van-cell>
                            <van-cell
                                v-for="(item, index) in categoryData"
                                :key="index"
                                :title="item.typename"
                                clickable
                                @click="categoryFun(item.typeid)"
                            >
                                <template #right-icon> <van-radio :name="item.typeid" /> </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
                <div class="year">
                    <h2><img src="/layuiadmin/account/img/year.png" alt="" /> 年份筛选</h2>
                    <van-radio-group v-model="cyear">
                        <van-cell-group>
                            <!-- <van-cell title="2023以来" clickable @click="filterYear('')">
                                <template #right-icon> <van-radio name="" /> </template>
                            </van-cell> -->
                            <van-cell title="2022以来" clickable @click="filterYear('')">
                                <template #right-icon> <van-radio name="" /> </template>
                            </van-cell>
                            <van-cell title="2021" clickable @click="filterYear('2021')">
                                <template #right-icon> <van-radio name="2021" /> </template>
                            </van-cell>
                            <van-cell title="2020" clickable @click="filterYear('2020')">
                                <template #right-icon> <van-radio name="2020" /> </template>
                            </van-cell>
                            <van-cell title="2019" clickable @click="filterYear('2019')">
                                <template #right-icon> <van-radio name="2019" /> </template>
                            </van-cell>
                            <van-cell title="2018" clickable @click="filterYear('2018')">
                                <template #right-icon> <van-radio name="2018" /> </template>
                            </van-cell>
                            <van-cell title="2017" clickable @click="filterYear('2017')">
                                <template #right-icon> <van-radio name="2017" /> </template>
                            </van-cell>
                            <van-cell title="2016" clickable @click="filterYear('2016')">
                                <template #right-icon> <van-radio name="2016" /> </template>
                            </van-cell>
                            <van-cell title="2016前" clickable @click="filterYear('2015')">
                                <template #right-icon> <van-radio name="2015" /> </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="category" closeable close-icon-position="top-right" position="bottom" :style="{ height: '90%' }">
            <h1>移入其他类别</h1>
            <div>
                <h2>选择类别</h2>
                <div class="addType">
                    <van-field v-model="typeVal" placeholder="请输入类别名称" />
                    <button @click="addType()">新增类别</button>
                </div>
                <div class="ydType">
                    <van-cell v-for="(item, index) in categoryData" :key="index" :title="item.typename" clickable>
                        <template #title>
                            <span>{{ item.typename }}</span>
                            <button class="del" @click="delType(item.typeid)">删除类别</button>
                            <button @click="move(item.typeid)">移入此类别</button>
                        </template>
                    </van-cell>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import api from "@/request/api/book";
import { Toast } from "vant";
import $ from "jquery";
export default {
    data() {
        return {
            list: [],
            count: 0,
            loading: false,
            finished: false,
            giveup: "",
            typeid: "0",
            cyear: "",
            page: 0,
            size: 10,
            filter: false,
            category: false,
            categoryData: [],
            typeVal: "",
            result: []
        };
    },
    components: {},
    mounted() {
        this.$store.dispatch("actionsHead", { type: false, title: "个人中心", iconType: false });
        this.getTypeList();
    },
    methods: {
        getCasesList() {
            api.casesList({
                giveup: this.giveup,
                page: this.page,
                size: this.size,
                typeid: this.typeid,
                cyear: this.cyear
            }).then((res) => {
                if (res.code == 0) {
                    this.result = [];
                    this.loading = false;
                    this.count = res.data.count;
                    if (this.page == 1) {
                        this.list = res.data.list;
                    } else {
                        this.list = this.list.concat(res.data.list);
                    }
                    if (this.list.length >= this.count) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                }
            });
        },
        onLoad() {
            this.page = this.page + 1;
            this.getCasesList();
        },
        filterYear(val) {
            this.cyear = val;
            this.page = 1;
            this.getCasesList();
            this.filter = false;
        },
        categoryFun(val) {
            if (val == "") {
                this.giveup = 1;
            } else {
                this.giveup = "";
            }
            this.typeid = val;
            this.page = 1;
            this.getCasesList();
            this.filter = false;
        },
        reapply(casesid) {
            api.casesReapply(
                this.$qs.stringify({
                    casesId: casesid,
                    cyear: this.cyear
                })
            ).then((res) => {
                if (res.code == 0) {
                    if (res.code == 0) {
                        Toast({
                            message: res.data.result,
                            position: "top"
                        });
                        // if (res.data.pdfUrl != "" && res.data.pdfUrl != undefined) {
                        //     window.open(res.data.pdfUrl);
                        // }
                        this.page = 1;
                        this.getCasesList();
                    } else {
                        Toast.fail("申请失败");
                    }
                }
            });
        },
        update(casesid, giveup) {
            var that = this;
            $.ajax({
                type: "get",
                url: "https://user.tsgyun.com/cases/update",
                async: true,
                xhrFields: { withCredentials: true },
                data: {
                    casesid: casesid,
                    giveup: giveup
                },
                success: function(data) {
                    if (data.code == 0) {
                        Toast({
                            message: "操作成功",
                            position: "top"
                        });
                        that.page = 1;
                        that.getCasesList();
                    } else {
                        Toast.fail("操作失败");
                    }
                }
            });
        },
        //typeAdd
        getTypeList() {
            api.typeList({ size: 100 }).then((res) => {
                if (res.code == 0) {
                    this.categoryData = res.data;
                }
            });
        },
        addType() {
            api.typeAdd({ typeName: this.typeVal }).then((res) => {
                if (res.code == 0) {
                    Toast({
                        message: "添加类别成功",
                        position: "top"
                    });
                    this.getTypeList();
                    this.typeVal = "";
                } else {
                    Toast({
                        message: res.msg,
                        position: "top"
                    });
                }
            });
        },
        delType(id) {
            api.typeDel([id]).then((res) => {
                if (res.code == 0) {
                    Toast({
                        message: "删除类别成功",
                        position: "top"
                    });
                    this.getTypeList();
                } else {
                    Toast({
                        message: res.msg,
                        position: "top"
                    });
                }
            });
        },
        move(id) {
            api.casesMove({
                casesid: this.result.join(","),
                typeid: id
            }).then((res) => {
                if (res.code == 0) {
                    Toast({
                        message: "移入类别成功",
                        position: "top"
                    });
                    this.category = false;
                    this.getTypeList();
                    this.getCasesList();
                } else {
                    Toast({
                        message: res.msg,
                        position: "top"
                    });
                }
            });
        }
    }
};
</script>
<style lang="less">
.bookshelf {
    background: #f2f2f2;
    height: 100%;
    .title {
        text-align: center;
        height: 2.7rem;
        line-height: 2.7rem;
        background: #fff;
        border-bottom: 1px solid #f2f2f2;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 100;
        i {
            display: inline-block;
            height: 100%;
            border-left: 1px solid #f2f2f2;
        }
        span {
            vertical-align: top;
            margin: 0;
            padding: 0;
            width: 40%;
            display: inline-block;
        }
    }
    .van-list {
        margin-top: 2.7rem;
        .van-checkbox {
            display: inline-block;
            vertical-align: top;
        }
        .van-cell {
            margin-bottom: 0.6rem;
            background: #fff;
            padding: 0.7rem;
            .custom-title {
                font-size: 1rem;
                color: #333;
            }
        }
        .au {
            padding: 0rem 0 0.2rem;
            border-bottom: 1px dashed #d7d7d7;
            color: #999;
            margin-bottom: 0.7rem;
            font-size: 0.8rem;
        }
        span {
            color: #999;
        }
        .btnP {
            float: right;
            a {
                background-color: #fff;
                color: #43a0f8;
                border: 1px solid #43a0f8;
                font-size: 0.8rem;
                padding: 0rem 0.3rem;
                margin: 0 0.3rem;
                display: inline-block;
                vertical-align: top;
            }
        }
        button {
            font-size: 0.8rem;
            border: 1px solid #43a0f8;
            padding: 0 0.3rem;
        }
    }

    .van-popup {
        h1 {
            font-size: 1rem;
            text-align: center;
            margin-top: 0.8rem;
        }
        h2 {
            // border-bottom: 1px solid #f6f6f6;
            font-size: 1rem;
            margin: 0.5rem 0;
            border: 0;
        }
        > div {
            padding: 1rem;
        }
        .van-cell {
            padding: 0.33333rem 0.85333rem;
        }
        .year {
            h2 {
                margin-top: 0.5rem;
            }
        }
        .addType {
            padding-bottom: 0.5rem;
            .van-cell {
                border: 0;
                background: #f3f3f3;
                padding: 0.33333rem 0.85333rem;
                width: 70%;
                height: 2rem;
                display: inline-block;
                input {
                    min-height: 1.2rem;
                }
            }
            button {
                width: 30%;
                height: 2rem;
                background: #178bf8;
                border: 1px solid #178bf8;
                border-top-right-radius: 0.5rem;
                border-bottom-right-radius: 0.5rem;
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
                color: #fff;
                padding: 0.2rem 0.3rem;
                vertical-align: top;
            }
        }
        .ydType {
            .van-cell {
                line-height: 1rem;
                button {
                    float: right;
                    background: #178bf8;
                    border: 1px solid #178bf8;
                    color: #fff;
                    padding: 0.1rem 0.3rem;
                    margin-left: 0.2rem;
                }
                button.del {
                    background: #fff;
                    color: #178bf8;
                }
            }
        }
    }
}
</style>
